import { camelizeKeys, decamelizeKeys } from 'humps'
import { NONE } from '../schemas/index'
import { API_KEY } from 'environmentConstants'
import { normalize } from 'normalizr'
import http from 'axios'

const API_ROOT = '/r/api/common/'

function callApi(endpoint, requestType, schema, data, dataGetter) {
  if (endpoint.indexOf(API_ROOT) === -1) {
    endpoint = API_ROOT + endpoint
  }

  if (endpoint.indexOf('token=') === -1) {
    const symbol = endpoint.indexOf('?') === -1 ? '?' : '&'
    endpoint = endpoint + symbol + 'token=' + API_KEY
  }

  if (typeof data !== 'undefined') {
    data = decamelizeKeys(data)
  }

  if (requestType === REQUEST_GET) {
    data = { params: data }
  }

  return http[requestType](endpoint, data).then(response => {
    const camelizedJson = camelizeKeys(response.data)

    if (schema === NONE) {
      return camelizedJson
    }

    let responseData = camelizedJson

    if (dataGetter) {
      responseData = dataGetter(camelizedJson)
    }

    const normalized = responseData ? normalize(responseData, schema) : {}

    return Object.assign({}, camelizedJson, normalized)
  })
}

export const CALL_API = Symbol('Call API')
export const REQUEST_GET = 'get'
export const REQUEST_POST = 'post'
export const REQUEST_PUT = 'put'
export const REQUEST_DELETE = 'delete'

export default store => next => action => {
  const callAPI = action[CALL_API]
  if (typeof callAPI === 'undefined') {
    return next(action)
  }

  let { endpoint } = callAPI
  const { bailout, data, requestType, schema, types, dataGetter } = callAPI

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState())
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL')
  }

  if (!schema) {
    throw new Error('Specify a schema')
  }

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types')
  }

  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.')
  }

  if (
    [REQUEST_GET, REQUEST_PUT, REQUEST_POST, REQUEST_DELETE].indexOf(
      requestType
    ) === -1
  ) {
    throw new Error(
      'Expected requestType to be one of "GET", "PUT", "POST", "DELETE"'
    )
  }

  if (typeof bailout !== 'undefined' && typeof bailout !== 'function') {
    throw new Error('Expected bailout to either be undefined or a function')
  }

  if (typeof dataGetter !== 'undefined' && typeof dataGetter !== 'function') {
    throw new Error('Expected dataGetter to either be undefined or a function')
  }

  if (bailout && bailout(store.getState())) {
    return Promise.resolve()
  }

  const [REQUEST, SUCCESS, FAILURE] = types
  const actionData = {
    [REQUEST]: action[REQUEST],
    [SUCCESS]: action[SUCCESS],
    [FAILURE]: action[FAILURE]
  }
  delete action[REQUEST]
  delete action[SUCCESS]
  delete action[FAILURE]

  function actionWith(data) {
    const finalAction = Object.assign({}, action, data)
    delete finalAction[CALL_API]
    return finalAction
  }

  const actionDataFor = (type, fn) => {
    const data = actionData[type] || {}
    return typeof data === 'function' ? fn(data) : data
  }

  next(actionWith({ type: REQUEST, ...actionData[REQUEST] }))

  return callApi(endpoint, requestType, schema, data, dataGetter).then(
    response =>
      next(
        actionWith({
          type: SUCCESS,
          response,
          ...actionDataFor(SUCCESS, data => data(response))
        })
      ),
    error =>
      next(
        actionWith({
          type: FAILURE,
          error: error.data,
          ...actionDataFor(FAILURE, data => data(error.data))
        })
      )
  )
}



// WEBPACK FOOTER //
// ../src/middleware/api.js